import {EmailRuleDto} from "../services/rules/dto/EmailRuleDto";

export interface RulesState {
    rules: EmailRuleDto[];
}

export const initialRulesState: RulesState = {
    rules: [],
};
